import { isExpired } from '~/helpers/Expiration';
import Vue from 'vue';
export default function ({ store, app, $axios, redirect }) {
  $axios.onRequest(config => {

    if (!store.state.auth.jwt || !store.state.auth.user.token) {
      disconnectUser(store, app, redirect);
      return config;
    }

    config.headers.common['Authorization'] =
      store.state.auth.user.token_type + ' ' + store.state.auth.user.token;

    return config;
  });

  $axios.onResponseError((error) => {
    const errorCodes = [];
    const response = error.response.data._response;
    const isPlannificationRoute = ('/planification' === window.location.pathname);
    if (response.code === RESPONSE.ERRORS.INVALID_TOKEN && !isPlannificationRoute) {
      disconnectUser(store);
    }
    if(RESPONSE.ERRORS[response.code] && RESPONSE.ERRORS[response.code].show){
      Vue.$toast.open({
        message:  response.message || 'Something went wrong!',
        type: 'error',
      });
    }
  });



  $axios.onResponse(response => {
    const successCodes = [
      //RESPONSE.SUCCESS.USERS_OK,
      RESPONSE.SUCCESS.INS200_02,
      RESPONSE.SUCCESS.INS200_04,
      RESPONSE.SUCCESS.INS200_03,
      RESPONSE.SUCCESS.CAT200_02,
      RESPONSE.SUCCESS.CAT200_04,
      RESPONSE.SUCCESS.CAT200_03,
      RESPONSE.SUCCESS.CAT200_05,
      RESPONSE.SUCCESS.CAT200_06,
      RESPONSE.SUCCESS.CAT200_09,
      RESPONSE.SUCCESS.ITM200_02,
      RESPONSE.SUCCESS.ITM200_03,
      RESPONSE.SUCCESS.ITM200_04,
      RESPONSE.SUCCESS.CATITM200_05,
      RESPONSE.SUCCESS.PRA200_02,
      RESPONSE.SUCCESS.PRA200_03,
      RESPONSE.SUCCESS.PRA200_04,
      RESPONSE.SUCCESS.PCK200_02,
      RESPONSE.SUCCESS.PCK200_03,
      RESPONSE.SUCCESS.PCK200_04,
      RESPONSE.SUCCESS.U200_02,
      RESPONSE.SUCCESS.U200_03,
      RESPONSE.SUCCESS.U200_04,
      RESPONSE.SUCCESS.CMPT200_02,
      RESPONSE.SUCCESS.CMPT200_03,
      RESPONSE.SUCCESS.CMPT200_04
    ];

    const warningCodes = [];

    if (response.data && response.data._response) {
      if (successCodes.includes(response.data._response.code)) {
        const message = response.data._response.message || 'Opération terminée avec succès.';
        Vue.$toast.success(message);
      } else if (warningCodes.includes(response.data._response.code)) {
        console.log('show warning toast');
      }
    }
  });
}

async function disconnectUser(store) {
  await store.dispatch('auth/logout');
}


export const RESPONSE = {
  ERRORS : {
    INVALID_TOKEN: 'L401_02',
    BAD_REQUEST: '400_00',
    INS406_00:{
      code : 'INS406_00',
      show : true
    },
    CAT200_07:{
      code : 'CAT200_07',
      show : true
    },
    CAT404_00:{
      code : 'CAT404_00',
      show : true
    },
    CAT404_01:{
      code : 'CAT404_01',
      show : true
    },
    G406_03 : {
      code : 'G406_03',
      show : true
    },
    G406_01 :  {
      code : 'G406_01',
      show : true
    },
    G406_02 : {
      code : 'G406_02',
      show : true
    }
  },
  SUCCESS : {
    USERS_OK : 'U200_00',
    INS200_02 : 'INS200_02',
    INS200_04 : 'INS200_04',
    INS200_03 : 'INS200_03',
    CAT200_02 : 'CAT200_02',
    CAT200_04 : 'CAT200_04',
    CAT200_03 : 'CAT200_03',
    CAT200_05:'CAT200_05',
    CAT200_06:'CAT200_06',
    CAT200_09:'CAT200_09',
    ITM200_02 : 'ITM200_02',
    ITM200_03 : 'ITM200_03',
    ITM200_04 : 'ITM200_04',
    CATITM200_05 : 'CATITM200_05',
    PRA200_02 : 'PRA200_02',
    PRA200_03 : 'PRA200_03',
    PRA200_04 : 'PRA200_04',
    PCK200_02 : 'PCK200_02',
    PCK200_03 : 'PCK200_03',
    PCK200_04 : 'PCK200_04',
    U200_02 : 'U200_02',
    U200_03 : 'U200_03',
    U200_04 : 'U200_04',
    CMPT200_02 : 'CMPT200_02',
    CMPT200_03 : 'CMPT200_03',
    CMPT200_04 : 'CMPT200_04'
  },
  WARNING : {}
};
